module.exports = __webpack_public_path__ + "img/tab_item04.11ff6f1c.png";